import { defineMessages } from 'react-intl';

export const apiErrorSnackbarMessages = defineMessages({
  clientErrorDescription: {
    id: 'helpers.api-error-snackbar.client-error-description',
    defaultMessage: "We couldn't complete this request. Please review your information and try again.",
  },
  serverErrorDescription: {
    id: 'helpers.api-error-snackbar.server-error-description',
    defaultMessage:
      'Something went wrong. Please try again. If this problem continues, please <contact-us-link>contact us</contact-us-link>.',
  },
  apiErrorPassthrough: {
    id: 'helpers.api-error-snackbar.passthrough',
    defaultMessage: '{message}',
  },
});
